import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DAYJS_LOCALES } from './locales';
import { useUiLanguage } from './useUiLanguage';

/**
 * What a LocalizationProvider needs for the current language: the dayjs locale (month and
 * weekday names in the calendar) and the pickers' own button and aria texts.
 *
 * MUI X ships no Serbian pickers locale, so the texts come from our translation files like
 * everything else. Only the ones these screens can actually show are set; anything else
 * stays MUI's English default.
 */
export const usePickerLocale = () => {
  const { t } = useTranslation();
  const language = useUiLanguage();

  return useMemo(
    () => ({
      adapterLocale: DAYJS_LOCALES[language],
      localeText: {
        previousMonth: t('picker.previousMonth'),
        nextMonth: t('picker.nextMonth'),
        openPreviousView: t('picker.openPreviousView'),
        openNextView: t('picker.openNextView'),
        cancelButtonLabel: t('picker.cancel'),
        clearButtonLabel: t('picker.clear'),
        okButtonLabel: t('picker.ok'),
        todayButtonLabel: t('picker.today'),
        datePickerToolbarTitle: t('picker.selectDate'),
        fieldDayPlaceholder: () => t('picker.dayPlaceholder'),
        fieldMonthPlaceholder: () => t('picker.monthPlaceholder'),
        fieldYearPlaceholder: () => t('picker.yearPlaceholder')
      }
    }),
    [language, t]
  );
};
